import { render, staticRenderFns } from "./salon.vue?vue&type=template&id=7b7cd3c2&scoped=true&"
import script from "./salon.vue?vue&type=script&lang=js&"
export * from "./salon.vue?vue&type=script&lang=js&"
import style0 from "./salon.vue?vue&type=style&index=0&id=7b7cd3c2&lang=scss&scoped=true&"
import style1 from "./salon.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7cd3c2",
  null
  
)

export default component.exports